import { dataFileEditSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFileEditSolid = /*#__PURE__*/createIcon(dataFileEditSolid)
export default IconFileEditSolid
